import { CommonChapter, CommonSkillField, CommonWorkedChapter } from '@codidae/common-types';
import { Field } from 'components/children-select-field/children-select-field';
import Flex from 'components/flex/flex';
import styles from './chapters.module.scss';

export default function ParentFieldList({
  disabledFields,
  enabledFields,
  chapters,
  onSelect,
  workedChapters,
}: {
  enabledFields: CommonSkillField[];
  disabledFields: CommonSkillField[];
  chapters: CommonChapter[];
  onSelect: (selectedFieldId: number) => void;
  workedChapters: CommonWorkedChapter[];
}) {
  console.log({ enabledFields });
  return (
    <Flex direction="column" width="100%" pad={15} gap={15}>
      <div className={styles.subtitle}>Matières choisies</div>
      <Flex gap={15} direction="column" width="100%">
        {enabledFields.map((field) => (
          <Field key={field.id} chapters={chapters} field={field} workedChapters={workedChapters} onSelect={onSelect} />
        ))}
      </Flex>
      <div className={styles.subtitle}>Matières disponibles</div>
      <Flex gap={15} direction="column" width="100%" className={styles.disabledFields}>
        {disabledFields.map((field) => (
          <Field
            key={field.id}
            chapters={chapters}
            field={field}
            workedChapters={workedChapters}
            onSelect={console.log}
          />
        ))}
      </Flex>
    </Flex>
  );
}
